import { useState, useEffect, useCallback } from 'react'
import api from '../services/api'

/**
 * Hook que mantiene el estado de validaciones pendientes del usuario actual.
 * El modal semanal se monta en cualquier shell y lee este hook.
 */
export function useValidacionesPendientes() {
  const [pendientes, setPendientes] = useState([])
  const [cargando, setCargando] = useState(true)

  const cargar = useCallback(async () => {
    setCargando(true)
    try {
      const r = await api.get('/fichajes/validaciones/pendientes')
      setPendientes(r.data || [])
    } catch {
      setPendientes([])
    } finally {
      setCargando(false)
    }
  }, [])

  useEffect(() => { cargar() }, [cargar])

  const validar = useCallback(async (id) => {
    await api.post(`/fichajes/validaciones/${id}/validar`)
    setPendientes((prev) => prev.filter((v) => v.id !== id))
  }, [])

  const rechazar = useCallback(async (id, observaciones, hora_propuesta) => {
    await api.post(`/fichajes/validaciones/${id}/rechazar`, { observaciones, hora_propuesta })
    setPendientes((prev) => prev.filter((v) => v.id !== id))
  }, [])

  const validarTodas = useCallback(async () => {
    const r = await api.post('/fichajes/validaciones/validar-todas')
    setPendientes([])
    return r.data
  }, [])

  return { pendientes, cargando, recargar: cargar, validar, rechazar, validarTodas }
}
